<div *ngFor="let msg of errorForControl()" class="alert alert-danger" role="alert">
  {{msg}}
</div>
